// Typelizer digest 9a89754b0e0136bc691f9cf696bb066c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /pivots/:pivot_id/irrigations */
  create: (
    params: { pivotId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/pivots/:pivot_id/irrigations', params, options),
    method: 'post',
  }),

  /** PATCH /pivots/:pivot_id/irrigations/:id */
  update: (
    params: { pivotId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/pivots/:pivot_id/irrigations/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /pivots/:pivot_id/irrigations/:id */
  destroy: (
    params: { pivotId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/pivots/:pivot_id/irrigations/:id', params, options),
    method: 'delete',
  }),
}
